// OWNER: AREA-OPS (dashboard, applications/*, suppressions, audit, system). Components go in src/features/ops.
// Key/value variables available to rules and templates as app.vars.*.
import { useQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'
import { applicationQuery } from '@/api/queries/applications'
import { ErrorState } from '@/components/QueryState'
import { Card, CardBody } from '@/components/ui/card'
import { SkeletonText } from '@/components/ui/skeleton'
import { UnsavedChangesScope } from '@/features/ops/UnsavedChangesScope'
import { VariablesEditor } from '@/features/ops/VariablesEditor'

export const Route = createFileRoute('/applications/$appId/variables')({
  staticData: { crumb: 'Variables' },
  validateSearch: (s: Record<string, unknown>): { view?: 'json' } => ({
    view: s.view === 'json' ? 'json' : undefined,
  }),
  component: AppVariablesPage,
})

function AppVariablesPage() {
  const { appId } = Route.useParams()
  const app = useQuery(applicationQuery(appId))
  const { view } = Route.useSearch()
  const navigate = Route.useNavigate()
  if (app.isError) return <ErrorState error={app.error} onRetry={() => void app.refetch()} />
  if (!app.data)
    return (
      <Card>
        <CardBody className="pt-4">
          <SkeletonText lines={6} />
        </CardBody>
      </Card>
    )
  return (
    <UnsavedChangesScope>
      <VariablesEditor
        app={app.data}
        mode={view ?? 'table'}
        onModeChange={(m) =>
          void navigate({
            search: (prev) => ({ ...prev, view: m === 'json' ? m : undefined }),
            replace: true,
          })
        }
      />
    </UnsavedChangesScope>
  )
}
